module.exports = __webpack_public_path__ + "public/img/padCode.b09d0967.png";